let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("idH5H")).then(() => parcelRequire('a7dE6'));